import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from '@auth/auth.component';
import { AuthGuard } from '@auth/auth.guard';
import { AuthSsoComponent } from '@auth/auth-sso/auth-sso.component';
import { ErrorScreenComponent } from './error-screen/error-screen.component';
import { StatusComponent } from './status/status.component';
import { PingComponent } from './ping/ping.component';
import { VersionComponent } from './version/version.component';
import { SessionCallRedirectComponent } from './session-call-redirect/session-call-redirect.component';
import { RedirectTestComponent } from './redirect-test/redirect-test.component';
const routes: Routes = [
  {
    path: 'error-page',
    component: ErrorScreenComponent,
    pathMatch: 'full',
  },
  {
    path: 'signin',
    component: AuthComponent,
    pathMatch: 'full',
  },
  {
    path: 'sso',
    component: AuthSsoComponent,
    pathMatch: 'full',
  },
  {
    path: 'version',
    component: VersionComponent,
    pathMatch: 'full',
  },
  {
    path: 'ping',
    component: PingComponent,
    pathMatch: 'full',
  },
  {
    path: 'status',
    component: StatusComponent,
    pathMatch: 'full',
  },
  {
    path: 'status1',
    component: RedirectTestComponent,
  },
  {
    path: 'r/s/:sessionId',
    component: SessionCallRedirectComponent,
  },
  {
    path: 'specialist',
    loadChildren: () => import('./+specialist/specialist.module').then((m) => m.SpecialistModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: '/specialist/calls',
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: '/specialist/calls',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutes {}
